"use client";

import { Transition } from "@headlessui/react";
import cn from "classnames";
import { FC, Fragment, ReactNode, useState } from "react";
import FeatureCard from "./FeatureCard";
import FeatureOverview from "./FeatureOverview";

export type FeatureCardProps = {
  cardContent: ReactNode;
  featureContent: ReactNode;
  button?: {
    viewMore?: string;
    viewLess?: string;
    dlt?: string;
    dld?: string;
  };
};

type FeaturesOverviewLayoutProps = {
  featureCards: FeatureCardProps[];
};

export const FeaturesOverviewLayout: FC<FeaturesOverviewLayoutProps> = ({
  featureCards,
}) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(0);

  const handleActiveState = (index: number) => {
    setActiveIndex(null);

    if (activeIndex !== index) {
      setTimeout(() => {
        setActiveIndex(index);
      }, 300);
    }
  };

  return (
    <div className="initialize-analytics-dynamically grid grid-cols-1 sm:grid-flow-dense sm:grid-cols-2 lg:grid-cols-3">
      {featureCards.map((card, index) => {
        const isActive = activeIndex === index;

        return (
          <Fragment key={`feature-card-${index}`}>
            <FeatureCard
              cardContent={card.cardContent}
              button={card.button}
              isActive={isActive}
              index={index}
              setActiveIndex={handleActiveState}
            />
            <Transition
              as="div"
              show={isActive}
              unmount={false}
              className="overflow-hidden sm:col-span-2 lg:col-span-3"
              enter="transition-all duration-300"
              enterFrom="opacity-0 max-h-0 -translate-y-0.5"
              enterTo="opacity-100 max-h-full translate-y-0"
              leave="transition-all duration-300"
              leaveFrom="opacity-100 max-h-full translate-y-0"
              leaveTo="opacity-0 max-h-0 -translate-y-0.5"
            >
              <FeatureOverview>{card.featureContent}</FeatureOverview>
            </Transition>
          </Fragment>
        );
      })}
    </div>
  );
};
